import React, { useEffect, useState } from "react";
import "../../styles/CertificateComponent.css";
import { getGalleryImages } from "../../services/getAllApi";

const CertificateGallery = () => {
  const [certificates, setCertificates] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchCertificateImages = async () => {
      try {
        const response = await getGalleryImages("Certificates");
        setCertificates(Array.isArray(response?.data?.images) ? response.data.images : []);
      } catch (error) {
        console.error("Error fetching images:", error);
      }
    };
    fetchCertificateImages();
  }, []);

  return (
    <>
      <div className="line relative top-[2.7rem] w-full left-[3rem]"></div>
      <h1 className="title animate-fade-in relative top-[3.2rem] left-[3rem] text-2xl sm:text-3xl md:text-4xl lg:text-6xl text-center">
        Certificates
      </h1>

      <div className="certificate-component-container">
        <div className="gallery_container">
          <div className="gallery_grid">
            {certificates.length > 0 ? (
              certificates.map((certificate, index) => (
                <div
                  key={index}
                  className="gallery_item"
                  onClick={() => setSelectedImage(`${"https://console.fbsedu.in/storage/app/"}/${ certificate.image_path }`)}
                >
                  <img

                    src={`${"https://console.fbsedu.in/storage/app/"}/${certificate.image_path}`}
                    alt={`Thumbnail ${index + 1}`}
                    className="thumbnail"
                  />
                </div>
              ))
            ) : (
              <p>No images available</p>
            )}
          </div>
        </div>
      </div>

      {/* Image Popup */}
      {selectedImage && (
        <div className="popup_overlay" onClick={() => setSelectedImage(null)}>
          <div className="popup_content">
            <img src={selectedImage} alt="Enlarged Certificate" />
          </div>
        </div>
      )}
    </>
  );
};

export default CertificateGallery;
